
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Pleural_mesothelioma",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Pleural_mesothelioma.vue